import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { token } from "@atlaskit/tokens";

import { ContentBlock, EmbeddedVideo } from "@/libraries/design/components";
import { wacToken } from "@/libraries/design/foundations";
import { SECTION_DIVIDER_HEIGHTS } from "@/libraries/design/utils";
import { Row } from "@/libraries/wpl/foundations/src";

export const RovoInnovationsVideo = () => {
    const intl = useIntl();

    return (
        <UFOSegment name="homepage-rovo-innovations-video">
            <section css={mainSectionStyles}>
                <div css={contentSectionStyles}>
                    <Row layout="8">
                        <ContentBlock
                            title={intl.formatMessage({
                                id: "HomePageTemplateV2.RovoInnovationVideo.Title",
                                defaultMessage:
                                    "Hot off the press: What’s new in AI?"
                            })}
                            titleAs="h2"
                            text={intl.formatMessage({
                                id: "HomePageTemplateV2.RovoInnovationVideo.Text",
                                defaultMessage:
                                    "Agents in Jira are now in open beta and Rovo can connect to MCP-enabled third-party apps, such as Amplitude, Box, Canva, Figma, Intercom, and more."
                            })}
                            callToActionProps={{
                                link: {
                                    text: intl.formatMessage({
                                        id: "HomePageTemplateV2.RovoInnovationVideo.CTA",
                                        defaultMessage: "Watch the full video"
                                    }),
                                    href: "/blog/ai/rovo-ai-agents-at-work",
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "ctaSection",
                                        "data-product-key": "home",
                                        "data-label-english":
                                            "Watch the full video"
                                    }
                                }
                            }}
                            alignment="center"
                        />
                    </Row>
                </div>
                <div css={videoSectionStyles}>
                    <Row layout="10">
                        <EmbeddedVideo
                            embedUrl="https://youtu.be/YNDHFg_uNcw"
                            title="Rovo at work: AI agents in action"
                            thumbnail={{
                                src: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EXEC.png",
                                alt: ""
                            }}
                        />
                    </Row>
                </div>
            </section>
        </UFOSegment>
    );
};

RovoInnovationsVideo.displayName = "RovoInnovationsVideo";

const mainSectionStyles = css({
    marginBlock: token("space.800")
});

const contentSectionStyles = css({
    backgroundColor: wacToken("color.extended.purple200"),
    paddingBlockStart: token("space.800"),
    paddingBlockEnd: token("space.400")
});

const videoSectionStyles = css({
    position: "relative",
    ["::before"]: {
        content: "",
        backgroundColor: wacToken("color.extended.purple200"),
        width: "100%",
        display: "block",
        position: "absolute",
        zIndex: "-1",
        height: "50%",
        paddingBlockEnd: "0.25px" // to address occasionally visible white line/gap
    },
    ["::after"]: {
        content: "",
        backgroundColor: wacToken("color.extended.purple200"),
        width: "100%",
        display: "block",
        position: "absolute",
        zIndex: "-1",
        insetBlockStart: "50%",
        clipPath: "polygon(0 100%, 100% 0, 0 0)",
        height: `${SECTION_DIVIDER_HEIGHTS.mobile}px`,
        [media.above.sm]: {
            height: `${SECTION_DIVIDER_HEIGHTS.tablet}px`
        },
        [media.above.md]: {
            height: `${SECTION_DIVIDER_HEIGHTS.desktop}px`
        }
    }
});
